<template>
  <div
    class="bg__color--white padding__tb--12"
    v-if="teams_infos"
  >
    <div class="container">
      <div class="d-md-flex justify-content-md-end">
        <span>
          {{ translate(content.collected_amount) }}

          <app-money
            class="bold color--prim"
            :amount="amount"
          />
        </span>
      </div>

      <div class="d-md-flex justify-content-md-center">
        <a
          class="btn btn__size--small bold"
          :href="teams_infos.invite_url"
          v-if="translate(content.cta) && teams_infos.invite_url"
        >
          {{ translate(content.cta) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { useI18n } from '@/vendors/i18n'
import { whenever } from '@/utils/utils'
import axios from '@/vendors/axios/axios'

import AppMoney from '&/atoms/AppMoney.vue'

const { slug, content } = defineProps({
  slug: { type: String, required: true },
  content: { type: Object, default: () => ({}) },
})

const { translate } = useI18n()
const { getProject } = useProjectStore()
const { project } = getProject({ id: slug, dependencies: [slug] })

const teams_infos = ref()

const amount = computed(() => parseFloat(teams_infos.value?.amount || 0) * 100)

whenever(project, () => {
  axios.get(`https://www.relaispourlavie.be/wp-json/rfl/v1/getteamsinfos/?koalect_id=${project.value.id}`)
    .then(({ data }) => teams_infos.value = data)
}, { immediate: true })
</script>

<style scoped lang="scss">
.container {
  color: #282535;
  font-size: rem(14px);
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  @include mq(sm) {
    justify-content: flex-end;
    gap: 24px;
  }

  @include mq(md) {
    font-size: rem(18px);
    display: grid;
    grid-template-columns: minmax(0, 1fr) 300px;
  }
}

.btn {
  background: #FDB913;
  border-radius: 4px;
  font-size: rem(14px);
  color: #422778;

  &:hover {
    background: darken(#FDB913, 5%);
  }
}
</style>